function _AwaitValue(value) {
  this.wrapped = value;
}

function _AsyncGenerator(gen) {
  var front, back;

  function send(key, arg) {
    return new Promise(function (resolve, reject) {
      var request = {
        key: key,
        arg: arg,
        resolve: resolve,
        reject: reject,
        next: null
      };

      if (back) {
        back = back.next = request;
      } else {
        front = back = request;
        resume(key, arg);
      }
    });
  }

  function resume(key, arg) {
    try {
      var result = gen[key](arg);
      var value = result.value;
      var wrappedAwait = value instanceof _AwaitValue;
      Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) {
        if (wrappedAwait) {
          resume(key === "return" ? "return" : "next", arg);
          return;
        }

        settle(result.done ? "return" : "normal", arg);
      }, function (err) {
        resume("throw", err);
      });
    } catch (err) {
      settle("throw", err);
    }
  }

  function settle(type, value) {
    switch (type) {
      case "return":
        front.resolve({
          value: value,
          done: true
        });
        break;

      case "throw":
        front.reject(value);
        break;

      default:
        front.resolve({
          value: value,
          done: false
        });
        break;
    }

    front = front.next;

    if (front) {
      resume(front.key, front.arg);
    } else {
      back = null;
    }
  }

  this._invoke = send;

  if (typeof gen.return !== "function") {
    this.return = undefined;
  }
}

if (typeof Symbol === "function" && Symbol.asyncIterator) {
  _AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
    return this;
  };
}

_AsyncGenerator.prototype.next = function (arg) {
  return this._invoke("next", arg);
};

_AsyncGenerator.prototype.throw = function (arg) {
  return this._invoke("throw", arg);
};

_AsyncGenerator.prototype.return = function (arg) {
  return this._invoke("return", arg);
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

document.addEventListener("load", function () {
  //alert("Hi from fotoAlbom.js");
  //Назачаем обработчик клика по фото
  var x = document.querySelectorAll(".faStart >img");

  for (var i = 0; i < x.length; i++) {
    //fbid - фото блок id
    if (!!x[i].dataset && !!x[i].dataset.fbid) {
      x[i].onclick = FA.fotoView;
      var elem = document.createElement("b");
      elem.innerHTML = "Альбом";
      elem.setAttribute('data-fbid', x[i].dataset.fbid);
      elem.onclick = FA.fotoView;
      x[i].parentNode.appendChild(elem);
    }
  }

  FotoAlbom.querySelector(".faPrev").onclick = FA.prev;
  FotoAlbom.querySelector(".faNext").onclick = FA.next;
  FotoAlbom.querySelector(".faOff").onclick = FA.hide;
  /*Разные имена событий у разных браузеров*/

  document.addEventListener("fullscreenchange", fullScrChange);
  document.addEventListener("webkitfullscreenchange", fullScrChange);
  document.addEventListener("mozfullscreenchange", fullScrChange);
  document.addEventListener("MSFullscreenChange", fullScrChange);
}, true);
var W = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
var H = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
var FotoAlbom = document.getElementById('FotoAlbom');

function ajax_get$1(url, callback) {
  var xmlhttp = new XMLHttpRequest();

  xmlhttp.onreadystatechange = function () {
    if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
      try {
        //var data = JSON.parse(xmlhttp.responseText);
        //static files = JSON.parse(xmlhttp.responseText);
        callback(JSON.parse(xmlhttp.responseText));
      } catch (err) {
        //console.log(err.message + " in " + xmlhttp.responseText);
        return;
      }
    }
  };

  xmlhttp.open("GET", url, true);
  xmlhttp.send();
}

function fullScreen(o) {
  (o.webkitRequestFullScreen || o.mozRequestFullScreen || o.requestFullScreen).call(o);
}

function fullScreenCancel(o) {
  (o.webkitCancelFullScreen || o.mozCancelFullScreen || o.cancelFullScreen || o.exitFullscreen).call(o);
}

function fullScrChange() {
  /*fullScrEl будет содержать элемент находящийся в полноэкранном режиме. 
    Если событие сработало при закрытии (после нажатия ESC), fullScrEl будет undefined или null*/
  var fullScrEl = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;

  if (fullScrEl == null) {
    //null или undefined. Если произошёл выход из fullScr
    FA.hide();
    fullScreenCancel(document);
  }
}

class FA {} //class FA

_defineProperty(FA, "ImgPtr", 0);

_defineProperty(FA, "divPtr", 0);

_defineProperty(FA, "imgNum", 0);

_defineProperty(FA, "imgs", document.querySelectorAll('.faImgBox > img'));

_defineProperty(FA, "bufNum", FA.imgs.length);

_defineProperty(FA, "buf", FotoAlbom.querySelectorAll('.faImgBox'));

_defineProperty(FA, "files", []);

_defineProperty(FA, "topMsg", FotoAlbom.querySelector('.faTopMsg'));

_defineProperty(FA, "btmMsg", FotoAlbom.querySelector('.faBtmMsg'));

_defineProperty(FA, "imgCount", FotoAlbom.querySelector('.faImgCount'));

_defineProperty(FA, "prevBtn", FotoAlbom.querySelector('.faPrev'));

_defineProperty(FA, "nextBtn", FotoAlbom.querySelector('.faNext'));

_defineProperty(FA, "note", function (txt) {
  //FA.btmMsg[FA.btmMsg.value ? "value" : "innerHTML"] = "some value";
  if (txt) FA.btmMsg.innerHTML = FA.imgs[FA.divPtr].note;else FA.btmMsg.innerHTML = ''; //if(txt) FA.btmMsg.value=FA.imgs[FA.divPtr].note;
  //else FA.btmMsg.value='';
});

_defineProperty(FA, "fotoView", function (e) {
  var o = e.target;
  fullScreen(FotoAlbom); //console.log(o);
  //alert(o['click']);
  //if(isMobile && t==1) return false;

  var startId = 0; //Первое фото Id = 0 

  var g = o.dataset.fbid; //addEventListener("popstate",function(){

  window.onpopstate = function (event) {
    //Юзер нажал кнопку "назад"
    //alert('onpopstate');
    if (FotoAlbom.style.display == 'block') FA.hide(); //enableScroll();
    //if(document.location.hash!='#foto') alert(document.location.hash);
    //alert(document.location.hash + ", state: " + JSON.stringify(event.state));
  };

  history.pushState({
    page: 1
  }, "title 1", "#foto");
  FotoAlbom.addEventListener('touchstart', FA.handleTouchStart, {
    passive: false
  });
  FotoAlbom.addEventListener('touchmove', FA.handleTouchMove, false);
  FotoAlbom.addEventListener('touchend', FA.handleTouchEnd, false);
  document.addEventListener("keydown", FA.keyDown, false);
  FA.ImgPtr = startId;
  FA.divPtr = 0; //disableScroll();

  FA.files = null;
  ajax_get$1('imgData.php?p=' + PgId + '&g=' + g + '&w=' + W + '&h=' + H, function (data) {
    FA.files = data; //FA.files=JSON.parse(data);

    FA.imgNum = FA.files.length; //

    FA.imgs[0].src = FA.files[startId].src; //

    FA.imgs[0].alt = FA.files[startId].alt;
    FA.imgs[0].note = FA.files[startId].note; //Показываем первое фото

    FA.buf[FA.divPtr].style.display = 'block';
    FA.imgCount.innerHTML = FA.ImgPtr + 1 + '/' + FA.imgNum; //счетчик

    FA.nextBtn.disabled = 0; //Сделать кнопку активной

    if (FA.ImgPtr == 0) FA.prevBtn.disabled = 1; //Сделать кнопку не активной

    if (FA.ImgPtr + 1 >= FA.imgNum) FA.nextBtn.disabled = 1; //Сделать кнопку не активной
    //if(FA.imgs[FA.divPtr].note) FA.note.innerHTML='<p>'+FA.imgs[FA.divPtr].note+'</p>';
    //else FA.note.innerHTML='';

    FA.note(FA.imgs[FA.divPtr].note);
    FotoAlbom.style.display = 'block'; //FotoAlbom.style.visibility = 'visible';
    //FotoAlbom.style.opacity = '1';

    FotoAlbom.focus();
    /*//Предзагрузка следующего фото
    if(FA.imgNum >1){//Если есть еще фото в списке, загружаем
    	FA.imgs[1].src=FA.files[startId+1].src; //
    	FA.imgs[1].alt=FA.files[startId+1].alt;
    	FA.imgs[1].note=FA.files[startId+1].note;
    }*/
    //Предзагрузка фото справа

    var preLoadPtr = FA.ImgPtr + 1;

    if (preLoadPtr < FA.imgNum) {
      //Если есть еще фото в списке, загружаем
      var p1 = FA.divPtr + 1;
      if (p1 >= FA.bufNum) p1 = 0;
      FA.imgs[p1].src = FA.files[preLoadPtr].src; //

      FA.imgs[p1].alt = FA.files[preLoadPtr].alt;
      FA.imgs[p1].note = FA.files[preLoadPtr].note;
    } //Предзагрузка фото слева


    preLoadPtr = FA.ImgPtr - 1;

    if (preLoadPtr >= 0) {
      //Если есть еще фото в списке, загружаем
      var p1 = FA.divPtr - 1;
      if (p1 < 0) p1 = FA.bufNum - 1;
      FA.imgs[p1].src = FA.files[preLoadPtr].src; //

      FA.imgs[p1].alt = FA.files[preLoadPtr].alt;
      FA.imgs[p1].note = FA.files[preLoadPtr].note;
    }
  });
});

_defineProperty(FA, "next", function () {
  //e.stopPropagation();
  //e.preventDefault(); //
  //alert('isMobile='+e);
  //console.log('isMobile='+isMobile);
  //if(isMobile && t==1) return false;
  //Если больше нет фото справа
  if (FA.ImgPtr + 1 >= FA.imgNum) return; //Скрываем текущее фото

  FA.buf[FA.divPtr].style.display = 'none'; //Инкрементируем указатели файлов и блоков DIV

  if (++FA.divPtr >= FA.bufNum) FA.divPtr = 0;
  FA.ImgPtr++; //Показываем следующее фото предзагруженное предыдущим next() или в fotoView()

  FA.buf[FA.divPtr].style.display = 'block'; //Выводим дополнительную информацию (описание фото, счетчик)
  //if(FA.imgs[FA.divPtr].note) FA.note.innerHTML='<p>'+FA.imgs[FA.divPtr].note+'</p>';
  //else FA.note.innerHTML='';

  FA.note(FA.imgs[FA.divPtr].note);
  FA.imgCount.innerHTML = FA.ImgPtr + 1 + '/' + FA.imgNum; //счетчик

  FA.prevBtn.disabled = 0; //Сделать кнопку активной

  if (FA.ImgPtr + 1 >= FA.imgNum) FA.nextBtn.disabled = 1; //Сделать кнопку не активной
  //Предзагрузка следующего фото

  var preLoadPtr = FA.ImgPtr + 1;

  if (preLoadPtr < FA.imgNum) {
    //Если есть еще фото в списке, загружаем
    var p1 = FA.divPtr + 1;
    if (p1 >= FA.bufNum) p1 = 0;
    FA.imgs[p1].src = FA.files[preLoadPtr].src; //

    FA.imgs[p1].alt = FA.files[preLoadPtr].alt;
    FA.imgs[p1].note = FA.files[preLoadPtr].note;
  }
});

_defineProperty(FA, "prev", function () {
  //if(isMobile && t==1) return false;
  //Если больше нет фото слева
  if (FA.ImgPtr - 1 < 0) return; //Скрываем текущее фото
  //FA.buf[FA.divPtr].classList.add("divHide");

  FA.buf[FA.divPtr].style.display = 'none'; //Инкрементируем указатели файлов и блоков DIV

  if (--FA.divPtr < 0) FA.divPtr = FA.bufNum - 1;
  FA.ImgPtr--; //console.log("XX1",'FA.divPtr='+FA.divPtr+', FA.ImgPtr='+FA.ImgPtr+', FA.imgNum='+FA.imgNum);
  //Показываем следующее фото предзагруженное предыдущим next() или в fotoView()

  FA.buf[FA.divPtr].style.display = 'block'; //Выводим дополнительную информацию (описание фото, счетчик)
  //if(FA.imgs[FA.divPtr].note) FA.note.innerHTML='<p>'+FA.imgs[FA.divPtr].note+'</p>';
  //else FA.note.innerHTML='';

  FA.note(FA.imgs[FA.divPtr].note);
  FA.imgCount.innerHTML = FA.ImgPtr + 1 + '/' + FA.imgNum; //счетчик

  FA.nextBtn.disabled = 0; //Сделать кнопку next активной

  if (FA.ImgPtr <= 0) FA.prevBtn.disabled = 1; //Сделать кнопку prev не активной
  //Предзагрузка следующего фото

  var preLoadPtr = FA.ImgPtr - 1;

  if (preLoadPtr >= 0) {
    //Если есть еще фото в списке, загружаем
    var p1 = FA.divPtr - 1;
    if (p1 < 0) p1 = FA.bufNum - 1;
    FA.imgs[p1].src = FA.files[preLoadPtr].src; //

    FA.imgs[p1].alt = FA.files[preLoadPtr].alt;
    FA.imgs[p1].note = FA.files[preLoadPtr].note;
  }
});

_defineProperty(FA, "hide", function () {
  FotoAlbom.removeEventListener("touchstart", FA.handleTouchStart, {
    passive: false
  }); // 

  FotoAlbom.removeEventListener("touchmove", FA.handleTouchMove, false); // 

  FotoAlbom.removeEventListener("touchend", FA.handleTouchEnd, false); // 

  document.removeEventListener("keydown", FA.keyDown, false);
  FotoAlbom.style.display = 'none'; //enableScroll();

  fullScreenCancel(document);
});

_defineProperty(FA, "keyDown", function (e) {
  //if(e.shiftKey) return true; 
  if (e.keyCode == '27') {
    //Esc
    e.preventDefault();
    FA.hide();
  } else if (e.keyCode == '33' || e.keyCode == '37') {
    //PgUp или Стрелка влево
    e.preventDefault();
    FA.prev();
  } else if (e.keyCode == '34' || e.keyCode == '39') {
    //PgDn или Стрелка вправо
    e.preventDefault();
    FA.next();
  } //alert(e.keyCode);

});

_defineProperty(FA, "xDown", 0);

_defineProperty(FA, "yDown", 0);

_defineProperty(FA, "isEvTch", 0);

_defineProperty(FA, "handleTouchStart", function (evt) {
  //evt.stopImmediatePropagation();
  //evt.stopPropagation();
  //evt.preventDefault(); //Закомментировал, чтобы работало редактирование комментариев в хроме.
  FA.xDown = evt.touches[0].clientX;
  FA.yDown = evt.touches[0].clientY; //return;

  var clssNm = evt.target.classList[0]; //alert(clssNm);

  switch (clssNm) {
    case 'faStart':
      FA.fotoView(evt);
      break;

    case 'faOff':
      evt.stopPropagation();
      evt.preventDefault();
      FA.hide();
      break;

    case 'faNext':
      evt.preventDefault();
      FA.next();
      break;

    case 'faPrev':
      evt.preventDefault();
      FA.prev();
      break;

    case 'faImg':
      FA.isEvTch = 1;
      break;

    default:
      FA.isEvTch = 0;
  }
});

_defineProperty(FA, "handleTouchEnd", function (evt) {
  return;
});

_defineProperty(FA, "handleTouchMove", function (evt) {
  evt.preventDefault();

  if (!FA.isEvTch) {
    return;
  }

  var xUp = evt.touches[0].clientX;
  var yUp = evt.touches[0].clientY;
  var xDiff = FA.xDown - xUp;
  var yDiff = FA.yDown - yUp;

  if (Math.abs(xDiff) > Math.abs(yDiff)) {
    /*most significant*/
    if (xDiff > 0) {
      //left swipe
      evt.preventDefault();
      FA.next();
    } else {
      //right swipe
      evt.preventDefault();
      FA.prev();
    }
  } else {
    FA.topMsg.classList.toggle("faMsgHide");
    FA.btmMsg.classList.toggle("faMsgHide");
  }
  /* reset values */


  FA.isEvTch = 0;
});

addEventListener("load", function () {
  var fa = new FA();
  document.getElementById('toggleMenu').onclick = toggleMenu; //обработчик формы поиска в шапке

  document.querySelector(".topHeader4 i").onclick = formSearchSubmit; //обработчики открывающие модальное окно

  document.getElementById('basket').onclick = basketLst; //обработчики закрывающие модальное окно и submit

  var x = document.querySelectorAll(".modal");

  for (var i = 0; i < x.length; i++) {
    x[i].querySelector("form").onsubmit = formSubmit;

    x[i].querySelector(".modalClose").onclick = function (e) {
      //Закрываем модальное окно
      var el = e.target;
      var modalWin = el.parentNode.parentNode.parentNode;
      modalWin.style.opacity = '0';
      modalWin.style.pointerEvents = 'none';
      var formAlert = modalWin.querySelector("form");
      formAlert.innerHTML = '';
    };
  }

  reSizeH("#mainMenu >.contentBox");
  reSizeH("#news >.contentBox");
  reSizeH("#argmntsBox >.contentBox"); //Подсветка ссылок при совпадении их урл с урл страницы

  var addr = location.pathname + location.search;
  if (addr == '/') var el = document.querySelector(".topMenu > a:nth-child(2)"); //В топ меню Главная это вторая по счету ссылка 
  else var el = document.querySelector('a[href*="' + addr + '"]');

  if (!!el) {
    if (el.classList.contains('menuItems')) {
      //http://ruseller.com/lessons.php?rub=32&id=2131
      el.classList.add("menuItemsCs"); //el.style.background = '#db4689';

      el.style.borderLeft = '1px solid #db0f6a'; //el.style.borderTop = '1px solid #db0f6a';
      //el.style.borderBottom = '1px solid #db0f6a';
    } else if (el.classList.contains('contentBox')) {//Блоки в sideBar сделаны с помощью <a class=contentBox
      //el.style.display = 'none'; //скрыть новость в sideBar, если она в центре.		
    } else {
      //el.style.background = '#eee';
      //el.style.color = '#db0f6a';
      el.style.textDecoration = 'underline';
    } //el.style.border = '1px solid #bfd2e6';
    //el.style.borderRight = '1px solid #2a6cb6';
    //el.style.borderBottom = '1px solid #fff';
    //el.style.color = '#444';


    el.style.cursor = 'default';
  }
}, true); //addEventListener("load",function)

window.onresize = function () {
  reSizeH("#mainMenu >.contentBox");
  reSizeH("#news >.contentBox");
  reSizeH("#argmntsBox >.contentBox");
};

function reSizeH(s) {
  //alert(s);
  var divs = document.querySelectorAll(s);
  var maxHeight = 0;
  var t;

  for (var j = 0; j < divs.length; j++) {
    //divs[j].removeAttribute("height");
    divs[j].style.height = 'auto';
    if ((t = divs[j].offsetHeight) > maxHeight) maxHeight = t;
  } //console.log('maxHeight=',maxHeight);


  for (var j = 0; j < divs.length; j++) divs[j].style.height = maxHeight + 'px';
}

function AJAXSubmit(oFormElement, callBack) {
  //Общий сабмит для HTML форм (<FORM), upload фото
  if (!oFormElement.action) {
    return;
  } //document.getElementById('pgId').value=pid;
  //oFormElement.querySelector('.pgId').value=pid;
  //oFormElement.pgId.value=pid;


  var oReq = new XMLHttpRequest();
  oReq.onload = callBack;
  oReq.open("post", oFormElement.action);
  oReq.send(new FormData(oFormElement));
}

function formSubmit(form) {
  var modalWin;
  modalWin = document.getElementById("price");
  modalWin.style.opacity = '0';
  modalWin.style.pointerEvents = 'none';
  return false; //var p=el.parentNode;
  //alert(form);

  var elTel = form.querySelector("input[name='tel']");
  var tel = elTel.value;
  var elEmail = form.querySelector("input[name='email']");
  var email = elEmail.value;

  if (email == '' && tel == '') {
    elEmail.title = 'Пожалуйста, введите емайл.';
    elEmail.style.boxShadow = "0 0 5px red"; //alert('Пожалуйста, введите Ваш телефон или емайл.');

    return false;
  } //var msg=document.getElementById('MsgTel');
  //var tel=document.getElementById('Tel').value;
  //document.querySelector("input[name='elementname']").value;


  AJAXSubmit(form, CallBackGetPrice);
  eraseCookie('zakaz'); //form.innerHTML='';

  return false;
}

function CallBackGetPrice() {
  //Ответ от PHP после отправки письма
  var t = this.responseText;
  var res = JSON.parse(t);

  if (res.status = 'Success') {
    window.location = './#close';
    alert('Заявка отправлена, в ближайщее время мы обязательно свяжемся с Вами.');
  } else alert(res.status);
}

function toggleMenu() {
  //var mobTopMenu=document.getElementById("mobTopMenu");
  var m = document.getElementById('mobTopMenu');
  if (m.style.display == 'none') m.style.display = 'block';else m.style.display = 'none'; //	if(!document.getElementById("mainMenuLst")){

  if (!document.querySelector("#mobTopMenu #mainMenuLst")) {
    //var mobTopMenuBox=document.getElementById("mobTopMenuBox");
    //var sideBar=document.getElementById("sideBar");
    //mobTopMenu.replaceWith(sideBar);
    //sideBar.style.display='block';
    ajax_get('menuMobile.php?id=24', function (d) {
      //console.log("d=",d);    
      m.innerHTML = d;
      var mainLst = document.getElementById("mainMenuLst");
      var catLst = document.getElementById('catMenuLst');
      var catHeader = document.querySelector(".catName > div:nth-child(1)");
      var mainHeader = document.querySelector(".catName > div:nth-child(2)");

      mainHeader.onclick = function () {
        console.log("mainHeader.onclick=" + mainLst.style.display);

        if (mainLst.style.display == 'none') {
          catLst.style.display = 'none';
          mainLst.style.display = 'block';
          catHeader.style.backgroundColor = "#7a8da9"; //

          mainHeader.style.backgroundColor = "#3e6aa9"; //
        } else return;
      };

      catHeader.onclick = function () {
        if (catLst.style.display == 'none') {
          mainLst.style.display = 'none';
          catLst.style.display = 'block';
          catHeader.style.backgroundColor = "#3e6aa9";
          mainHeader.style.backgroundColor = "#89a";
        } else return;
      }; //console.log("d=",d);


      return;
    });
  } //mainLst.style.display='block';
  //catLst.style.display='none';
  //catHeader.style.backgroundColor="#3e6aa9";
  //TopMenu.mainHeader.style.backgroundColor="#aaa";

}

function formSearchSubmit(e) {
  form = e.target.parentElement.parentElement;
  inpValue = form.querySelector("input[type=text]").value.trim();
  if (inpValue) form.submit();
}
/*Три функции для работы с Cookie*/


function createCookie(name, value, days) {
  var expires = "";

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') c = c.substring(1, c.length);

    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
}

function eraseCookie(name) {
  createCookie(name, "", -1);
}

HTMLFormElement.prototype.serialize = function () {
  var obj = {};
  var elements = this.querySelectorAll("input, select, textarea");

  for (var i = 0; i < elements.length; ++i) {
    var element = elements[i];
    var name = element.name;
    var value = element.value;

    if (name) {
      obj[name] = value;
    }
  } //return JSON.stringify( obj );


  return obj;
};
/*Формируем заказ*/


var zakaz = [];
var rdCook = readCookie("zakaz");
if (rdCook) zakaz = JSON.parse(rdCook);

if (Object.keys(zakaz).length > 0) {
  document.getElementById("basket").style.color = 'red'; //.classList.add("imgLeft");
} //console.log("zakazCookie",zakaz);


function basketLst() {
  //var modalPrice = document.getElementById("price");
  var modalWin;
  modalWin = document.getElementById("price"); //modalPrice.style.opacity='1';
  //modalPrice.style.pointerEvents='auto';

  var dForm = document.getElementById("dForm");
  dForm.innerHTML = '';
  var zl = '';
  var defn = {
    'tovar': 'Товар',
    'DN': 'диаметр',
    'quant': 'кол-во',
    'env': 'среда',
    'envT': 'Температура среды',
    'pressure': 'Давление',
    'materl': 'Материал исполнения',
    'connect': 'Тип присоединения'
  };

  for (var i = 0; i < zakaz.length; ++i) {
    var tov = zakaz[i];

    for (var key in tov) {
      zl += defn[key] + ': ' + tov[key] + ', ';
    }

    zl = zl.substring(0, zl.length - 2); //Убираем последнюю запятую и пробел в строке

    zl += '<br>';
  }

  dForm.innerHTML = zl;
  dForm.innerHTML += '<br>\
	<input name="tovName" type="hidden" value="' + zl + '">\
	<input name="org" type=text placeholder="Наименование организации" title=""><br>\
	<input name="name" type=text pattern="^[a-zA-Zа-яА-ЯёЁ ]+$" placeholder="Ваше имя" maxlength=30><br>\
	<input name="tel" type=tel pattern="^[\+0-9-]{11,17}$" placeholder="Ваш телефон" title=""><br>\
	<input type="email" name="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" placeholder="Ваш email"><br>\
	<input type="submit" value="Отправить"><br>';
  modalWin.style.opacity = '1';
  modalWin.style.pointerEvents = 'auto';
}

function ajax_get(url, callback) {
  var xmlhttp = new XMLHttpRequest();

  xmlhttp.onreadystatechange = function () {
    if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
      //console.log('responseText:' + xmlhttp.responseText);
      try {
        //var data = JSON.parse(xmlhttp.responseText);
        //aCml.data = JSON.parse(xmlhttp.responseText);
        callback(xmlhttp.responseText);
      } catch (err) {
        //console.log(err.message + " in " + xmlhttp.responseText);
        return;
      }
    }
  };

  xmlhttp.open("GET", url, true);
  xmlhttp.send();
}
